<template>
  <div id="chargeList">
    <div class="common_tit_wrap">
      <div class="common_page_tit">청구관리</div>
      <div class="common_page_desc">
        저압 모뎀 웹사이트
        <template v-if="userInfoDetail.userRole === 2 || userInfoDetail.userRole === 3">
          |
          <template v-if="userInfoDetail.affiliateCode != null">
            <template v-for="afc in afcList" v-if="afc.codeValue === userInfoDetail.affiliateCode">{{afc.codeName}}</template>
          </template>
          <template v-if="userInfoDetail.officeCode != null">
            <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === userInfoDetail.officeCode.substring(0, 5)">{{ofc1.codeName}}</template>
          </template>
        </template>
      </div>
    </div>
    <div class="common_list_wrap">
      <div class="common_list_top">
        <div class="common_list_top_select">
          <select v-model="selectSize" @change="search(1)">
<!--            <option value="10">10줄 표시</option>-->
<!--            <option value="20">20줄 표시</option>-->
            <option value="50">50줄 표시</option>
            <option value="100">100줄 표시</option>
            <option value="200">200줄 표시</option>
            <option value="500">500줄 표시</option>
          </select>
        </div>
        <div class="common_list_top_select" v-if="mySession.userRole === 4">
          <select v-model="searchParams.ofc1Select" @change="search(1)">
            <option value="">-- 본부 선택 --</option>
            <option v-for="item in ofc1List" :key="'ofc_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
          </select>
        </div>
        <div class="common_list_top_select">
          <vue-datepicker-local
            v-model="searchParams.chargeDate"
            inputClass="vdl_input"
            :local="ko"
            format="YYYY-MM"
            clearable
            show-buttons
            @confirm="search(1)"
            @cancel="search(1)"/>
        </div>
        <template v-if="mySession.userRole === 4">
          <div class="btn_top btn_green" @click="addCharge">청구 등록</div>
        </template>
      </div>
      <div class="common_list_middle">
        <div class="common_list_head">
          <div><span>본부</span></div>
          <div><span>청구년월</span></div>
          <div><span>저압</span></div>
          <div><span>고압</span></div>
          <div><span>전선도난</span></div>
          <div><span>세금계산서 등</span></div>
          <div><span>등록일</span></div>
          <div><span>수정</span></div>
          <div><span>삭제</span></div>
        </div>
        <div class="common_list_body">
          <div class="common_list_no_data" v-if="list.length <= 0">
            <img src="../../assets/common/bg_list_no_data.png"/>
            <span>대상 청구가 없습니다.</span>
          </div>
          <div :key="'charge_' + item.chargePid" v-for="item in list">
            <div>
              <span v-if="item.officeCode != null">
                <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === item.officeCode.substring(0, 5)">{{ofc1.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.chargeYear != null && item.chargeMonth != null">{{item.chargeYear}}년 {{item.chargeMonth}}월</span>
              <span v-else>-</span>
            </div>
            <div>
              <span class="btn_status fc_white bc_status_gray" @click="downloadFile(item.filePath + item.lowFile)" v-if="item.lowFile != null && item.lowFile.length > 0">다운로드</span>
              <span v-else>파일 없음</span>
            </div>
            <div>
              <span class="btn_status fc_white bc_status_gray" @click="downloadFile(item.filePath + item.highFile)" v-if="item.highFile != null && item.highFile.length > 0">다운로드</span>
              <span v-else>파일 없음</span>
            </div>
            <div>
              <span class="btn_status fc_white bc_status_gray" @click="downloadFile(item.filePath + item.stolenFile)" v-if="item.stolenFile != null && item.stolenFile.length > 0">다운로드</span>
              <span v-else>파일 없음</span>
            </div>
            <div>
              <span class="btn_status fc_white bc_status_gray" @click="downloadFile(item.filePath + item.taxFile)" v-if="item.taxFile != null && item.taxFile.length > 0">다운로드</span>
              <span v-else>파일 없음</span>
            </div>
            <div>
              <span v-if="item.regDate != null">{{item.regDate}}</span>
              <span v-else>-</span>
            </div>
            <div><span class="link fc_primary_blue" @click="editCharge(item)">수정</span></div>
            <div><span class="link fc_primary_blue" @click="deleteSelectedItem(item)">삭제</span></div>
          </div>
        </div>
      </div>
      <div class="common_bottom_wrap">
        <div class="common_list_page_wrap">
          <paginate
            v-model="pageParams.page"
            :pageCount="pageParams.totalPage"
            :clickHandler="search"
            :prevText="'<'"
            :nextText="'>'"
            :containerClass="'page_wrap'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '../../script/common'
import VueDatepickerLocal from 'vue-datepicker-local'
import chargeFiles from '../../script/chargeFiles'
import modemStop from '../../script/modemStop'

export default {
  components: {
    VueDatepickerLocal
  },
  data () {
    return {
      // Common
      mySession: {},
      ko: common.getDatepickerLocal(),
      userInfoDetail: JSON.parse(sessionStorage.getItem('userInfoDetail')),
      // Data
      afcList: [],
      ofcList: [],
      ofc1List: [],
      // Search
      searchParams: {
        ofc1Select: '', // 본부 1차 선택
        chargeDate: ''
      },
      // List
      filter: {
        page: 1,
        size: parseInt(this.selectSize)
      },
      selectSize: '50',
      list: [],
      // Paging
      pageParams: {
        hasNext: false,
        totalElements: 0,
        totalPage: 1,
        page: 10,
        size: parseInt(this.selectSize)
      }
    }
  },
  mounted () {
    console.log(JSON.parse(sessionStorage.userInfo))
    console.log(JSON.parse(sessionStorage.userInfoDetail))
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) ||
            common.checkValidateData('session', sessionStorage.getItem('ofcList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            if (this.$route.params != null && this.$route.params.searchParams != null) {
              const data = this.$route.params.searchParams
              if (data.ofc1Select != null && data.ofc1Select.length > 0) {
                this.searchParams.ofc1Select = data.ofc1Select
              }
              if (data.chargeDate != null && data.chargeDate.length > 0) {
                const chargeDate = new Date(data.chargeDate)
                this.searchParams.chargeDate = chargeDate.getFullYear().toString() + '-' + chargeDate.getMonth() + 1 < 10 ? '0' + (chargeDate.getMonth() + 1) : (chargeDate.getMonth() + 1).toString()
              }
              this.search(1)
            } else {
              this.search(1)
            }
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  methods: {
    // Button Action
    downloadFile (url) {
      common.fileDownload(url)
    },
    // Common
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    // List
    search (page) {
      this.filter = {
        page: page,
        size: parseInt(this.selectSize)
      }
      if (this.mySession.userRole === 2 || this.mySession.userRole === 3) {
        this.filter.officeCode = this.userInfoDetail.officeCode.substring(0, 5)
      } else {
        delete this.filter['officeCode']
        if (this.searchParams.ofc1Select != null && this.searchParams.ofc1Select !== '') {
          this.filter.officeCode = this.searchParams.ofc1Select
        }
      }
      delete this.filter['chargeYear']
      delete this.filter['chargeMonth']
      if (this.searchParams.chargeDate != null && typeof this.searchParams.chargeDate === 'object') {
        const chargeDate = new Date(this.searchParams.chargeDate)
        this.filter.chargeYear = chargeDate.getFullYear().toString()
        this.filter.chargeMonth = chargeDate.getMonth() + 1 < 10 ? '0' + (chargeDate.getMonth() + 1) : (chargeDate.getMonth() + 1).toString()
      }
      this.updateList()
    },
    updateList () {
      chargeFiles.getCharge(this.filter, response => {
        console.log('[청구관리] 목록', response)
        if (response.data.resultCode === 1) {
          const data = response.data.result.body
          let list = data.list
          for (let i = 0; i < list.length; i++) {
            list[i].filePath = '/upload/charge/' + list[i].chargeYear.toString().slice(2) + (list[i].chargeMonth < 10 ? '0' + list[i].chargeMonth : list[i].chargeMonth) + '/'
          }
          this.list = list
          this.pageParams = {
            hasNext: data.hasNext,
            totalElements: data.totalElements,
            totalPage: data.totalPage,
            page: this.filter.page,
            size: this.filter.size
          }
        } else {
          common.amsAlert('retry', '청구관리 목록을 불러오지 못했습니다.')
          this.list = []
          this.pageParams = {
            hasNext: false,
            totalElements: 0,
            totalPage: 1,
            page: 1,
            size: this.filter.size
          }
        }
      })
    },
    addCharge () {
      if ((this.mySession.subRole & 32) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      this.$router.push({
        name: 'ChargeForm',
        params: {
          type: 'add',
          searchParams: this.searchParams
        }
      })
    },
    editCharge (item) {
      if ((this.mySession.subRole & 32) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      const result = common.checkUserRole(this.mySession, 4, 'edit')
      if (!result.code) {
        return
      }
      if (this.mySession.userPid !== item.userPid) {
        common.amsAlert('general', '자신이 등록한 청구만 수정할 수 있습니다.')
        return
      }
      this.$router.push({
        name: 'ChargeForm',
        params: {
          type: 'edit',
          searchParams: this.searchParams,
          data: item
        }
      })
    },
    deleteSelectedItem (item) {
      if ((this.mySession.subRole & 32) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      const result = common.checkUserRole(this.mySession, 4, 'delete')
      if (!result.code) {
        return
      }
      if (this.mySession.userPid !== item.userPid) {
        common.amsAlert('general', '자신이 등록한 청구만 삭제할 수 있습니다.')
        return
      }
      if (confirm('선택한 청구를 삭제하시겠습니까?')) {
        modemStop.modemStop('delete', {
          isStop: true,
          pid: item.stopPid
        }, response => {
          console.log('[청구관리] 삭제', response)
          if (response.data.resultCode === 1) {
            common.amsAlert('general', '선택한 청구를 삭제했습니다.')
            this.updateList()
          } else {
            common.amsAlert('retry', '청구를 삭제하지 못했습니다.')
          }
        })
      }
    }
  }
}
</script>

<style scoped>
#chargeList {
  display: flex;
  flex-direction: column;
  margin: 36px auto 46px;
}

#chargeList .common_list_top > .common_list_top_select {
  margin: auto 0;
}

#chargeList .common_list_top > .common_list_top_select > .datepicker {
  height: 40px;
}

#chargeList .common_list_top > .btn_green {
  margin: auto 0 auto auto;
}

#chargeList .common_list_middle > .common_list_head > div,
#chargeList .common_list_middle > .common_list_body > div > div {
  flex-shrink: 1;
  width: 100%;
}

#chargeList .common_bottom_wrap > .common_list_page_wrap {
  margin: auto 0 auto auto;
}
</style>



// WEBPACK FOOTER //
// src/components/charge/ChargeList.vue